import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-open-icon',
  templateUrl: './open-icon.component.html',
  styles: []
})
export class OpenIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
